<template>
  <div>
    <myheader :backIntercept="true" @childBackEvent="back" headTitle="证书列表"></myheader>
    <div class="all_main flex-column">
      <van-dropdown-menu class="corp-box">
        <van-dropdown-item v-model="corpId" :options="corpLists" @change="onChangeCorp" />
      </van-dropdown-menu>
      <div class="flex1 main-box">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <div>
            <div v-for="(item, index) in certList" :key="index" v-show="certList.length > 0">
              <div class="list-item flex-row backgroundC_white bwhite_ative" @click="jumpDetails(item)">
                <div class="list-left-img">
                  <img src="@/assets/images/file.svg" />
                </div>
                <div class="flex1 list-item-center">
                  <div class="text14 textcolorblack font_weight_bold"
                    :class="{ 'text-decoration-line-through': failure(item) }">
                    {{ item.signetName }}
                    <!-- 已签发才有-->
                    <template v-if="item.certStatus === 3">
                      <span v-if="getExpireDays(item) <= 0" class="expire-warning">（已到期）</span>
                      <span v-else-if="getExpireDays(item) <= 30" class="expire-warning">（{{
                        getExpireDays(item) }}天后到期！）</span>
                    </template>
                  </div>
                  <div class="text12 textcolor666 margin_top_3"
                    :class="{ 'text-decoration-line-through': failure(item) }">
                    {{ '企业代码 ' + item.creditCode }}
                  </div>
                  <div class="text12 textcolor666 margin_top_3"
                    :class="{ 'text-decoration-line-through': failure(item) }">
                    <span>证书状态:</span>
                    <!--                    <span :class="{textcolorRed:item.certStatus===111}" style="margin-left: .5rem;">{{ item.certStatusText }}</span>-->
                    <span :style="{ color: colorObj[item.certStatus] }" style="margin-left: .5rem;">{{
                      item.certStatusText }}</span>
                    <span style="margin-left: 1rem;">印章类型:</span>
                    <span style="margin-left: .5rem;">{{ item.signetTypeText }}</span>
                  </div>
                  <div class="text12 textcolor666 margin_top_3"
                    :class="{ 'text-decoration-line-through': failure(item) }">
                    <span>持有人:</span>
                    <span style="margin-left: .5rem;">{{ item.staffName }}</span>
                  </div>
                </div>
                <div class="list-right-btn-box">
                  <!-- 不是证书办理人的时候 -->
                  <template v-if="!isAdmin">
                    <!-- 使用中 -->
                    <img v-if="item.certStatus === 112" src="@/assets/images/selected.svg" />
                    <!-- 已失效 且不是证书办理人的时候  或者已签发但证书已到期 -->
                    <img v-if="item.certStatus === 113 || (item.certStatus === 3 && getExpireDays(item) <= 0)"
                      src="@/assets/images/cert-failure.svg" />
                  </template>
                  <!--                  审核中-->
                  <img v-if="item.certStatus === 1 || item.certStatus === 6" src="@/assets/images/cert-audit.svg" />
                  <button v-if="item.flag === 'down'"
                    class="all_height_line16 text14 all_button20 bmain_active" style="padding: 0 .8rem;"
                    @click.stop="showDownCert(item)">下载</button>
                  <!--                  其他情况，是管理员  或者 是持有人的时候   -->
                  <img v-if="item.certStatus !== 4 && getShowBtn(item)" :src="menu"
                    @click.stop="onOperation(item, index)" />
                </div>
              </div>
              <div class="horizontal_line"></div>
            </div>
            <van-empty style="margin-top: 20vh;" :description="isAdmin ? '暂无证书，可以点击按钮申请证书' : '暂无数据'"
              v-show="certList.length === 0" />
          </div>
        </van-pull-refresh>
      </div>
    </div>
    <!-- 新办浮动按钮 -->
    <div v-if="isAdmin" class="fab-btn" @click="handleCorpBtn('0')">
      <van-icon name="plus" size="18" />
      <span class="fab-text">新办</span>
    </div>
    <van-popup class="popup-box" v-model:show="showManagerBottom" position="bottom">
      <div v-show="isAdmin">
        <!--      3已签收  112使用中  113已失效 111已过期-->
        <div
          v-show="(operationData.certStatus === 3 || operationData.certStatus === 113 || operationData.certStatus === 112 || operationData.certStatus === 111) && operationData.certSn"
          class="btn-box flex-space-between">
          <div v-show="!checkExpireDate()" class="btn-item" @click="handleCorpBtn('2')">
            <img src="@/assets/images/cert-xuqian.svg" alt="">
            <div>续签</div>
          </div>
          <div class="btn-item" @click="handleCorpBtn('1')">
            <img src="@/assets/images/cert-change.svg" alt="">
            <div>变更</div>
          </div>
          <div class="btn-item" @click="handleCorpBtn('3')">
            <img src="@/assets/images/cert-reset.svg" alt="">
            <div>补办</div>
          </div>
          <div class="btn-item" @click="handleCorpBtn('4')">
            <img src="@/assets/images/cert-zhuxiao.svg" alt="">
            <div>注销</div>
          </div>
        </div>
        <!--      如果是审核未通过和草稿状态 -->
        <div class="btn-box flex-space-between"
          v-show="operationData.certStatus === 5 || operationData.certStatus === 0">
          <div class="btn-item" @click="onEdit">
            <img src="@/assets/images/cert-edit.svg" alt="">
            <div>编辑</div>
          </div>
          <div class="btn-item" v-show="operationData.applyType === 0" @click="onDel">
            <img src="@/assets/images/cert-del.svg">
            <div>删除</div>
          </div>
        </div>
      </div>
      <!--            待签发  -->
      <!--         certType 1 Ukey证书  3移动证书 -->
      <div v-show="operationData.certStatus === 2" class="btn-box flex-space-between">
        <!--              如果是Ukey证书-->
        <template v-if="operationData.certType === 1 && isAdmin">
          <!--               如果是变更申请-->
          <!--                  applyType 0,"新办" 1,"变更" 2,"续签" 3,"补办" 4,"注销"-->
          <div class="btn-item" v-show="operationData.applyType === 1">
            <img src="@/assets/images/cert-change.svg" @click="onApiUrl" />
            <div>变更</div>
          </div>
          <div class="btn-item" v-show="operationData.applyType === 2">
            <div>续签</div>
            <img src="@/assets/images/cert-xuqian.svg" @click="onApiUrl">
          </div>
        </template>
      </div>
      <!--        本地并且已过期的证书-->
      <!-- <div v-show="operationData.certStatus === 111" class="btn-box flex-space-between">
        <div class="btn-item" @click="showDeleteCert">
          <img src="@/assets/images/cert-del.svg">
          <div>删除</div>
        </div>
      </div> -->
      <div style="height:.5rem;background-color: #ededed;"></div>
      <div class="cancel-btn" @click="showManagerBottom = false">
        取&nbsp;消
      </div>
    </van-popup>
    <!-- 极速补办弹框 -->
    <replace-cert-dialog :show.sync="showReplaceDialog" :cert-info="replaceCertInfo" @confirm="handleReplaceConfirm" />
  </div>
</template>

<script>
//certStatus 0 草稿   1 审核中  2 待签发   3 已签发  4 已注销  5未通过  6管理员审核
// certType 1 Ukey证书  3移动证书
import Vue from "vue";
import {
  Dialog,
  Empty,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  Icon
} from 'vant';
import ReplaceCertDialog from './modules/replaceCertDialog.vue';
import {
  getDownCertp10,
  installCert,
  deleteCert,
  getLocalCertList,
} from '../../utils/nativeCertSign.js'
import {
  getDeviceType,
  closeCurrentPage
} from '../../utils/nativeOtherOperate.js'

export default {
  components: {
    [Empty.name]: Empty,
    [PullRefresh.name]: PullRefresh,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
    ReplaceCertDialog,
  },
  data() {
    return {
      //企业id
      corpId: '',
      //企业信用代码
      creditCode: '',
      //是否下拉刷新
      refreshing: false,
      localCertList: [], //本地证书列表
      downList: [],//国富安接口返回的可以下载的证书列表
      //用户名
      userName: this.$store.state.loginInfo.userName,
      //
      signetList: ['合同专用章', '收货确认专用章', '交货确认专用章', '企业公章', '人事专用章', '招标专用章', '非招标专用章'],
      corpLists: [], //企业列表
      certList: [],//证书列表
      menu: require('@/assets/images/menu.svg'),
      showManagerBottom: false, //是否显示操作
      operationData: {}, //当前操作的数据
      colorObj: { //证书状态颜色 #f7b500
        0: '#6c757d',
        1: '#f7b500',
        2: '#fd7e14',
        3: '#198754',
        4: '#6f42c1',
        5: '#dc3545',
        6: '#3b71ca',
        111: '#b45309',
        112: '#2e7d32',
        113: '#a11e2c',
      },
      isAdmin: false, //是否是管理员
      // 极速补办弹框
      showReplaceDialog: false,
      replaceCertInfo: {},
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    //初始化
    init() {
      // 优先从路由参数获取企业ID，其次从 sessionStorage 恢复
      this.corpId = this.$route.query.corpId || sessionStorage.getItem('selectedCorpId') || '';
      this.creditCode = this.$route.query.creditCode
      this.getMyCorps();
    },
    getMyCorps() { //获取企业列表
      // 清空列表数据
      this.$get("/cert/api/getMyCorps").then((res) => {
        this.corpLists = []
        if (res.success) {
          const data = res.data || []
          for (let item of data) {
            this.corpLists.push({
              ...item,
              value: item.corpId,
              text: item.corpName
            })
          }
          if (this.corpLists.length > 0) {
            // 如果已有选中的企业ID（从路由参数或sessionStorage恢复），验证该企业是否在列表中
            if (this.corpId) {
              const selectedCorp = this.corpLists.find(item => item.corpId === this.corpId);
              if (selectedCorp) {
                this.isAdmin = selectedCorp.showCertManage;
              } else {
                // 如果选中的企业不在列表中，默认选中第一个
                this.corpId = this.corpLists[0].value;
                this.isAdmin = this.corpLists[0].showCertManage;
                sessionStorage.setItem('selectedCorpId', this.corpId);
              }
            } else {
              // 没有选中的企业，默认选中第一个
              this.corpId = this.corpLists[0].value;
              this.isAdmin = this.corpLists[0].showCertManage;
              sessionStorage.setItem('selectedCorpId', this.corpId);
            }
            this.getLocalCertList()
          }
        } else {
          this.$Toast(res.message || res.messageDetail)
        }
      });
    },
    //企业下拉列表改变
    onChangeCorp() {
      const data = this.corpLists.filter((item) => item.corpId === this.corpId)
      if (data && data.length > 0) {
        this.isAdmin = data[0].showCertManage;
      } else {
        this.isAdmin = false;
      }
      // 保存用户选择的企业ID到 sessionStorage
      sessionStorage.setItem('selectedCorpId', this.corpId);
      this.refreshing = true;
      this.onRefresh()
    },
    checkExpireDate() { //判断证书是否能续签
      let reslut = true
      if (this.operationData.expireDate) {
        const targetDate = new Date(this.operationData.expireDate)
        const currentDate = new Date()
        const timeDiff = targetDate - currentDate
        if (timeDiff <= 0) {
          reslut = false
        } else {
          const daysDiff = timeDiff / (1000 * 60 * 60 * 24)
          reslut = daysDiff > 30
        }
      }
      return reslut;
    },
    //
    back() {
      if (this.$route.query.appCode) {
        closeCurrentPage()
      } else {
        this.$router.go(-1)
      }
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      if (this.refreshing) {
        this.certList = [];
        this.refreshing = false;
      }
      this.getLocalCertList()
    },
    //先获取本地证书，再获取所有证书
    getLocalCertList() {
      // 清空列表数据
      this.$store.dispatch(this.$LoadShow, true)
      getLocalCertList(this.userName).then(res => {
        if (res) {
          const data = res ? JSON.parse(res) : []
          this.setLocalCertList(data)
        }
      }).catch(err => {
      }).finally(() => {
        this.getMakeList()
      })
    },
    //处理本地证书列表
    setLocalCertList(data) {
      //企业证书列表
      if (this.creditCode) {
        data = data.filter(item => {
          return item.subject.indexOf(this.creditCode) != -1;
        });
      }
      //当前时间
      let currentDate = new Date()
      for (let item of data) {
        //ios
        if (getDeviceType() === 'ios') {
          item.subject = decodeURIComponent(item.subject.replace(/\\x/g, '%'))
          console.log('ios-item.subject=', item.subject)
        } else {
          item.subject = item.subject.replace('\\', '')
        }
        let content = item.subject.split(',')
        for (let k of content) {
          if (k.indexOf('SERIALNUMBER=') == 0) {
            item.creditCode = k.substring(13, k.length)
          }
          if (k.indexOf('serialNumber=') == 0) {
            item.creditCode = k.substring(13, k.length)
          }
          if (k.indexOf('CN=') == 0) {
            item.corpName = k.substring(3, k.length)
            if (item.corpName === 'Dongsheng Petroleum (Mongolia)CO.') {
              item.corpName = 'Dongsheng Petroleum (Mongolia)CO.,LTD'
            }
          }
          if (k.indexOf('OU=') == 0 && !item.signetTypeText) {
            let tmp = k.substring(3, k.length)
            if (this.signetList.includes(tmp)) {
              item.signetTypeText = tmp
            }
          }
        }
        item.flag = 'local'
        //是否需要通过验证证书时间验证证书是否有效
        let expireDate = new Date(item.expireDate.replace(' ', 'T'))
        //ios
        if (getDeviceType() === 'ios') {
          expireDate = new Date(this.Tool.getDateForUtc(item.expireDate))
        } else if (getDeviceType() === 'android') {

        } else {
          expireDate = new Date(item.expireDate)
        }
        if (expireDate > currentDate) {
          item.certStatus = 112
          item.certStatusText = '使用中'
        } else {
          item.certStatus = 111
          item.certStatusText = '已过期'
        }
      }
      this.localCertList = JSON.parse(JSON.stringify(data)) //copy一下本地所有的证书
    },
    //
    getDateForUtc(date) {
      return new Date(Date.UTC(parseInt(date.substr(0, 2)) + 2000, parseInt(date.substr(2, 2)),
        parseInt(date.substr(4, 2))))
    },
    //获取待下载证书列表
    getMakeList() {
      this.$get("/cert/api/getMakeList?corpId=" + this.corpId)
        .then(res => {
          this.$store.dispatch(this.$LoadShow, false)
          if (res.success && res.data) {
            this.downList = res.data
            this.getCertList()
          } else {
            //this.$Toast('获取证书列表失败！')
          }
        }).catch(err => {
          this.$store.dispatch(this.$LoadShow, false)
        });
    },
    //获取证书列表
    getCertList() {
      this.certList = []
      const params = {
        corpId: this.corpId,
        pageParams: {
          current: 1,
          size: 200
        }
      }
      this.$post("/cert/api/queryCerts", params).then(res => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success) {
          const data = res.data && res.data.records ? res.data.records : []
          const localCertSn = this.localCertList.map(item => item.sn) //拿到本地证书的id
          for (let item of data) {
            // 如果不是管理员，就只显示持有人是登录人的证书
            if (!this.isAdmin && item.userName !== this.userName) {  //staffName 持有人 userName 持有人账号
              continue;
            }
            item.flag = 'api'
            const result = this.getDown(item)
            // 本地已有此证书，但是证书快到期了，使用了续签，续签完证书后，需要能下载新证书
            // 如果国富安的下载列表里有当前这个数据 & 待签发 & 移动证书 & 
            if(result.length > 0 && item.certStatus === 2 && item.certType === 3 && item.userName === this.userName){
              item.flag = 'down'
            }else if (!localCertSn.includes(item.certSn)) { //如果本地没有这个证书
              // 失效证书  = 全部已签发的证书 - 本地证书
              // 如果是这个证书的持有人，但是这个证书是已签发并且在本地没有，那就是已失效
              // certType 3移动证书
              if (item.userName === this.userName && item.certStatus === 3 && item.certType === 3) { //代表已签发
                item.certStatus = 113
                item.certStatusText = '已失效'
              }
              // // 持有人是当前登录人 & 移动证书 & 待签发 & 国富安的下载列表里没有当前的这个数据
              // if (item.userName === this.userName && item.certType === 3 && item.certStatus === 2 && result.length === 0) {
              //   item.certStatus = 112
              //   item.certStatusText = '使用中'
              // }
            } else { //如果本地有这个证书，就拿到本地这个证书的信息
              // 如果是 证书办理人 + 已签发 + 移动证书  再去替换本地证书状态
              if(item.userName === this.userName && item.certStatus === 3 && item.certType === 3){
                const localData = this.localCertList.filter(ele => ele.sn === item.certSn)
                if (localData && localData.length > 0) {
                  item = {
                    ...item,
                    ...localData[0],
                  }
                }
              }
            }
            this.certList.push(item)
          }
        } else {
          this.$Toast(res.message || res.messageDetail)
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
      });
    },
    //印模类型（公章，合同章，人力资源章等）:
    // 1 合同专用章
    // 2 收货确认专用章
    // 3 交货确认专用章
    // 4 企业公章
    // 5 人事专用章
    // 6 招标专用章
    // 7 非招标专用章
    //设置章类型文本
    setSignetTypeText(item) {
      switch (item.signetType) {
        case '1':
          item.signetTypeText = '合同专用章'
          break;
        case '2':
          item.signetTypeText = '收货确认专用章'
          break;
        case '3':
          item.signetTypeText = '交货确认专用章'
          break;
        case '4':
          item.signetTypeText = '企业公章'
          break;
        case '5':
          item.signetTypeText = '人事专用章'
          break;
        case '6':
          item.signetTypeText = '招标专用章'
          break;
        case '7':
          item.signetTypeText = '非招标专用章'
          break;
      }
    },
    //显示确认删除过期证书弹窗
    showDeleteCert() {
      Dialog.confirm({
        title: '提示',
        message: '确定删除该证书？',
        confirmButtonText: '删除',
        confirmButtonColor: '#0277FC'
      })
        .then(() => {
          this.delCert(this.operationData)
        })
        .catch(() => {
          // on cancel
        });
    },
    //删除过期证书
    delCert(item) {
      deleteCert(item.sn, this.userName).then(res => {
        if (res) {
          this.certList = this.certList.filter(items => {
            return items.sn != item.sn;
          });
          this.$Toast('删除成功！')
        } else {
          this.$Toast('删除失败！')
        }
      }).catch(err => {
        this.$Toast('删除失败！')
      })
    },
    getDown(data) { //是否可以下载
      const result = this.downList.filter(item => item.reqId === data.applyId)
      return result
    },
    //显示下载确认弹窗
    showDownCert(item) {
      Dialog.confirm({
        title: '提示',
        message: '确定下载证书？',
        confirmButtonText: '下载',
        confirmButtonColor: '#0277FC'
      })
        .then(() => {
          const result = this.getDown(item)
          this.downCert(result[0] || item)
        })
        .catch(() => {
          // on cancel
        });
    },
    //下载并安装证书
    downCert(item) {
      this.$store.dispatch(this.$LoadShow, true)
      getDownCertp10(item.corpName, item.creditCode, item.signetType, item.applyType, this.userName)
        .then(res => {
          console.log('getDownCertp10-=', res)
          if (res) {
            this.getMakeP7b(item, res)
          } else {
            this.$Toast('下载失败')
            this.$store.dispatch(this.$LoadShow, false)
          }
        }).catch(err => {
          this.$Toast('下载失败')
          this.$store.dispatch(this.$LoadShow, false)
        })
    },
    //
    getMakeP7b(item, p10) {
      //证书下载网络请求
      this.$post("/cert/api/makeP7b", JSON.stringify({
        applyType: item.applyType,
        creditCode: item.creditCode,
        corpName: item.corpName,
        signetType: item.signetType,
        raArguments: item.raArguments,
        raRequestId: item.raRequestId,
        p10Base64: p10,
      })).then(res => {
        if (res.success && res.data) {
          installCert(res.data, item.creditCode, item.signetType, this.userName).then(rel => {
            if (rel) {
              this.$Toast('下载安装成功！')
            } else {
              this.$Toast('下载安装失败！')
            }
          }).catch(e => {
            this.$Toast('下载安装失败！')
          }).finally(() => {
            this.$store.dispatch(this.$LoadShow, false)
            setTimeout(() => {
              this.getLocalCertList()
            }, 800)
          })
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast(res.message || res.messageDetail || '下载失败！')
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/cert/api/makeP7b', err)
        //this.getLocalList()
        this.$Toast('下载安装失败，请重试！')
      })
    },
    //跳转详情页
    jumpDetails(item) {
      // && item.status != '已过期'
      if (item.flag == 'local') { //如果是本地证书
        this.$store.commit('changeCertInfo', item)
        this.$router.push({
          path: 'certdetails',
          query: {
            certSn: item.sn
          }
        })
      }
    },
    // 获取证书剩余天数
    getExpireDays(item) {
      if (!item.expireDate) return 0;
      const expireDate = new Date(item.expireDate.replace(' ', 'T'));
      const currentDate = new Date();
      const timeDiff = expireDate - currentDate;
      return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    },
    failure(item) { //是否失效
      return item.certStatus === 113 || (item.certStatus === 3 && this.getExpireDays(item) <= 0)
    },
    getShowBtn(item) { //获取是否显示操作按钮
      let result = false
      if(this.isAdmin){
        //     3已签收  112使用中  113已失效
        if(item.certSn && (item.certStatus === 3 || item.certStatus === 113 || item.certStatus === 112 || item.certStatus === 111)){
          result = true
        }
        if (item.certStatus === 5 || item.certStatus === 0 ) {
          result = true
        }
      }
      // if (item.certStatus === 111) {
      //   result = true
      // }
      if (item.certStatus === 2) {
        if (this.isAdmin && (item.certType === 1 && (item.applyType === 1 || item.applyType === 2))) {
          result = true
        }
        // if (item.certType === 3 && item.userName === this.userName) {
        //   result = true
        // }
      }
      return result
    },
    onOperation(item, index) { // 操作
      this.showManagerBottom = true;
      this.operationData = item;
    },
    handleCorpBtn(type) { //点击按钮
      switch (type) {
        case '2': // 续签
          this.$router.push({
            name: 'corpCertApply',
            query: {
              applyType: type,
              corpId: this.corpId,
              certId: this.operationData.certId,
            }
          })
          break
        case '3': // 补办: 如企业认证时间早于证书申请时间，使用极速补办功能否则打开跳转补办页面
          const applyTime = new Date(this.operationData.applyTime).getTime() // 证书申请时间
          const corpAuditTime = new Date(this.operationData.corpAuditTime).getTime() // 企业认证时间
          if (this.operationData.applyTime && this.operationData.corpAuditTime && corpAuditTime < applyTime) {
            this.openReplaceDialog(this.operationData)
            break
          }
          this.$router.push({
            name: 'corpCertApply',
            query: {
              applyType: type,
              corpId: this.corpId,
              certId: this.operationData.certId,
            }
          })
          break
        default:
          this.$router.push({
            name: 'corpCertApply',
            query: {
              applyType: type,
              corpId: this.corpId,
            }
          })
          break
      }
    },
    openReplaceDialog(item) { //极速补办
      this.showManagerBottom = false; // 关闭底部操作框
      this.replaceCertInfo = item;
      this.showReplaceDialog = true;
    },
    // 极速补办确认
    handleReplaceConfirm(params) {
      this.showReplaceDialog = false;
      this.$store.dispatch(this.$LoadShow, true);
      const postParams = {
        corpId: this.corpId, // 企业ID
        certId: this.replaceCertInfo.certId, // 证书ID
        certSn: this.replaceCertInfo.certSn, // 证书序列号
        autoType: '2', // 极速补办
        mobile: this.$store.state.userInfo?.mobile, // 办理人手机号
        smsCode: params.smsCode, // 短信验证码
        applyMemo: params.applyMemo, // 补办原因
      }
      this.$post('/cert/api/supplCertApply', postParams).then((res) => {
        this.$store.dispatch(this.$LoadShow, false);
        if (res.success) {
          this.$Toast('补办申请提交成功！');
          this.getLocalCertList();
        } else {
          this.$Toast(res.message || res.messageDetail || '补办申请提交失败！');
        }
      }).catch((err) => {
        this.$store.dispatch(this.$LoadShow, false);
        console.log('fastReissue error:', err);
        this.$Toast('补办申请提交失败！');
      });
    },
    onApiUrl() { //待签发的续签和变更
      this.$get('/cert/api/getApiUrl').then((res) => {
        if (res.success) {
          window.open(res.data)
        } else {
          this.$Toast(res.message || res.messageDetail)
        }
      })
    },
    onEdit() { //编辑
      this.$router.push({
        name: 'corpCertApply',
        query: {
          applyType: this.operationData.applyType,
          corpId: this.corpId,
          certId: this.operationData.certId,
        }
      })
    },
    onDel() { //删除
      const that = this
      Dialog.confirm({
        title: `提示`,
        message: `确定删除${this.operationData.signetName}吗？`,
        confirmButtonText: '确定',
        confirmButtonColor: '#0277FC'
      }).then(() => {
        const params = {
          certId: this.operationData.certId,
        }
        that.$store.dispatch(this.$LoadShow, true)
        that.$get('/cert/api/removeCert', {
          params: params
        }).then((res) => {
          if (res.success) {
            that.$Toast('删除成功！')
            that.onChangeCorp()
          } else {
            that.$Toast(rel.message || rel.messageDetail)
          }
        }).finally(() => {
          that.$store.dispatch(this.$LoadShow, false)
        })
      })
        .catch(() => {
          // on cancel
        });
    },
  },

  beforeDestroy() {
    //自动回收
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/global.css";

.text-decoration-line-through {
  text-decoration: line-through;
}

.expire-warning {
  color: #dc3545;
  font-size: 0.6rem;
}

.corp-box {
  text-align: left;
  width: 100%;
  border-bottom: 1px solid #cccccc;
}

::v-deep .van-dropdown-menu__bar {
  height: 2.2rem;

  .van-dropdown-menu__item {
    justify-content: flex-start;
  }
}

::v-deep .van-dropdown-menu__title {
  color: #0277FC;
  max-width: 90%;
}

::v-deep .van-dropdown-item__option--active {
  color: #0277FC;
}

::v-deep .van-dropdown-item__icon {
  color: #0277FC;
}

.all_main {
  overflow: hidden;

  .main-box {
    overflow-y: auto;
    overflow-x: hidden;

    .list-item {
      padding: .8rem .5rem;
      overflow: hidden;

      .list-left-img {
        img {
          width: 0.8rem;
          height: 0.8rem;
          margin-right: 0.6rem;
        }
      }

      .list-item-center {
        margin-right: 0.6rem;
        word-break: break-all;
      }

      .list-right-btn-box {
        img {
          width: 1.2rem;
          height: 1.2rem;

          &:last-of-type {
            width: 0.8rem;
            height: 0.8rem;
          }
        }

        button {
          padding: 0 .8rem;
        }
      }
    }
  }
}

.fab-btn {
  position: fixed;
  right: 1rem;
  bottom: 1.5rem;
  padding: 0.5rem 1rem;
  background: #0277FC;
  border-radius: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  color: #fff;
  box-shadow: 0 2px 8px rgba(2, 119, 252, 0.3);
  z-index: 100;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:active {
    transform: scale(0.95);
    box-shadow: 0 1px 4px rgba(2, 119, 252, 0.2);
  }

  .fab-text {
    font-size: 0.75rem;
    font-weight: 500;
  }
}

.popup-box {
  font-size: .7rem;

  .btn-box {
    padding: 0.5rem 1rem;
    border-bottom: 1px solid #ccc;
  }

  .btn-item {
    flex: 1;
    display: flex;
    flex-flow: column;
    align-items: center;

    img {
      width: 1rem;
      height: 1rem;
      margin-bottom: 0.2rem;
    }
  }

  .cancel-btn {
    text-align: center;
    height: 2.4rem;
    line-height: 2.4rem;
    color: #999;
    border-top: 1px solid #ccc;
  }
}
</style>
